<template>
  <div class="activities">
    <div class="title">
      <div></div>
      评论列表
    </div>
    <div class="query">
      <div class="query-box">
        <el-input v-model="query" placeholder="酒吧名称/昵称/联系电话"></el-input>
      </div>
      <div class="query-box">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="inquire">查询</el-button>
      <el-button type="primary" @click="refresh">刷新</el-button>
         <el-button type="primary" @click="derive">导出</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>

        <el-table-column align="imagesUrl" label="用户头像">
          <template slot-scope="images">
            <el-image
              style="width: 50px; height: 50px"
              class="table-td-thumb"
              :src="images.row.headImages"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="wxName" label="昵称">
        </el-table-column>

           <el-table-column align="center" prop="phone" label="联系电话">
        </el-table-column>


        <el-table-column align="center" prop="barName" label="打卡酒吧名称">
        </el-table-column>
        <el-table-column align="center" prop="score" label="酒吧评分">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.score" disabled></el-rate>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="essay" label="评价内容">
           <template slot-scope="scope">
            <el-tooltip :content="scope.row.essay" placement="top">
              <p class="showOverTooltip">{{ scope.row.essay }}</p>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="createTime" label="创建日期">
        </el-table-column>

          <el-table-column align="center" prop="createTime" label="是否匿名">
              <template slot-scope="scope">
                {{scope.row.isAnonymous==true?'匿名':"非匿名"}}
              </template>
        </el-table-column>


        <el-table-column align="center" prop="" label="状态">
          <template slot-scope="scope">
            <div
              :class="
                scope.row.auditType == 2
                  ? 'active2'
                  : 'active'
              "
            >
              {{
                  scope.row.auditType == 2
                  ? "上架"
                  : "下架"
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="commentDetail(scope.row.id)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import { webCommentPage, IP,functiondownload } from "@/api/api";
export default {
  data() {
    return {
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "2",
          label: "上架",
        },
        {
          value: "3",
          label: "下架",
        },
      ],
      value: "",
      //  activityId: "",
      ruleList: [],
      query: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
      spotId: "",
    };
  },
  created() {
    this.query = this.$route.query.currentPage==undefined?"":this.$route.query.query;
    this.value = this.$route.query.value==undefined?"":this.$route.query.value;
     this.value = this.$route.query.value==undefined?"":this.$route.query.value;
    this.currentPage = this.$route.query.currentPage==undefined?1:Number(this.$route.query.currentPage);
    this.pageSize = this.$route.query.pageSize==undefined?10:Number(this.$route.query.pageSize);

    this.getList();
  },
  methods: {
          // 导出
    derive(){
       functiondownload('/web/comment/webCommentPageExportExcel',{ query: this.query,
        auditType: this.value,
        scenicSpotId: this.spotId,},true)
    },
    commentDetail(id) {
      this.$router.push("commentDetail?commentId=" + id+"&currentPage=" +this.currentPage +"&pageSize=" +this.pageSize +"&query=" +this.query+ "&value=" +this.value);
    },

    querys() {
      if (this.activityTime == null) {
        (this.startTime = ""), (this.endTime = "");
      }
    },
    //  获取评论列表
    async getList() {
      let res = await webCommentPage({
        query: this.query,
        auditType: this.value,
        scenicSpotId: this.spotId,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      });
      console.log(res);
      let { data } = res;
      //  边界判断
      // if (!data.itemList.length && this.currentPage !== 1) {
      //   this.currentPage -= 1;
      //   this.getList();
      // }
      this.tableData = data.itemList;
      this.total = data.totalSize;
    },
    // 刷新
    refresh() {
      this.query = "";
      this.value="",
      this.getList();
    },

    // 查询
    inquire() {
      this.getList();
    },

    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}

  .showOverTooltip {
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    /*这里是3行*/
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
.active {
  color: red;
}
.active2 {
  color: #33b959;
}
</style>